import { render, staticRenderFns } from "./SectorDashboard.vue?vue&type=template&id=0e67d16e"
import script from "./SectorDashboard.vue?vue&type=script&lang=js"
export * from "./SectorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports